import { ChangeDetectionStrategy, Component, inject, viewChild } from '@angular/core'
import { Uuid } from '@ftr/contracts/type/shared'
import { IconButtonComponent, PopoverDirective, ToastService } from '@ftr/foundation'
import { UrlIdSplitterService } from './url-id-splitter.service'
import { UrlSegmentsComponent } from './url-segments'

@Component({
  selector: 'ftr-url-id-selector',
  templateUrl: './url-id-selector.component.html',
  styleUrl: './url-id-selector.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconButtonComponent, PopoverDirective, UrlSegmentsComponent],
})
export class UrlIdSelector {
  private readonly urlIdSplitterService = inject(UrlIdSplitterService)
  private readonly toastService = inject(ToastService)

  private readonly popover = viewChild.required(PopoverDirective)

  protected readonly segments = this.urlIdSplitterService.segments

  protected async handleSelectedId(id: Uuid): Promise<void> {
    try {
      await navigator.clipboard.writeText(id)
      this.toastService.success('ID copied to clipboard', '', { timeOut: 2500 })
      this.popover().closeOverlay()
    } catch {
      this.toastService.error('Failed to copy ID to clipboard')
    }
  }
}
